export const tabFormatter = (tab) => {
  switch (tab) {
    case 'pharmacy':
      return '/pharmacy';
    case 'hra':
      return '/hra?noBackButton=true';
    case 'dependents':
      return '/manage-dependents';
    default:
      return '/home';
  }
};
